/* Archival redesign: quick add on product cards.
   Cards embed <div data-aa-qa><script type="application/json">{"c":color,"v":[[variantId,size,available],...]}</script></div>.
   This builds the desktop size bar + touch "+" button + bottom sheet, adds via /cart/add.js and then fires
   theme:cart:refresh, exactly like aa-product.js, so Palo Alto's cart drawer opens and the header count updates. */
(function () {
  if (window.__aaQuickAdd) return;
  window.__aaQuickAdd = true;

  var PLUS = '<svg class="aa-icon" width="18" height="18" viewBox="0 0 28 28" aria-hidden="true" focusable="false"><path d="M14.3 3 C 13.8 10, 14.5 18, 13.9 25.2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M3 14.4 C 10 13.7, 18 14.6, 25.4 13.9" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var PLUS_S = PLUS.replace('width="18" height="18"', 'width="11" height="11"');
  var CLOSE = '<svg class="aa-icon" width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M3.2 3.6 C 7 7.3, 11.6 11.9, 16.9 16.7" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M16.6 3.1 C 12.4 7.6, 8.1 11.6, 3.3 16.9" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round"/></svg>';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;
  var live = null;

  // v = [id, size, available, upcharge cents]. Buttons show the size only (Mike, Oct 13); the price is shown elsewhere.
  function sizeText(v) { return String(v[1]).toLowerCase(); }
  function usd(c) { c = +c || 0; return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
  // "$30 · 3xl+ $35": the one-line price note for the mobile size sheet, only when some sizes cost more
  function priceNote(vs, base) {
    var up = vs.filter(function (v) { return (+v[3] || 0) > 0; });
    if (!up.length || !base) return '';
    var first = up[0], amt = base + (+first[3]);
    var same = up.every(function (v) { return +v[3] === +first[3]; });
    return usd(base) + ' · ' + String(first[1]).toLowerCase() + (up.length > 1 ? '+' : '') + ' ' + (same ? usd(amt) : 'from ' + usd(amt));
  }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function say(t) {
    if (!live) { live = el('p', 'aa-visually-hidden'); live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite'); document.body.appendChild(live); }
    live.textContent = ''; setTimeout(function () { live.textContent = t; }, 30);
  }
  function titleOf(wrap) { var s = wrap.querySelector('.aa-card__row .aa-ui'); return s ? s.textContent.trim() : ''; }

  function add(id) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, json: j }; });
    }).then(function (res) {
      if (!res.ok) throw new Error(res.json.description || res.json.message || 'sorry, that could not be added.');
      // Palo Alto's cart drawer listens for this, refetches the cart and opens itself
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    });
  }

  /* ---- per-card build ---- */
  function build(host) {
    if (host.__aaApi) return;
    var data;
    try { data = JSON.parse(host.querySelector('script').textContent); } catch (e) { return; }
    var wrap = host.closest('.aa-cardw');
    var vs = data.v || [];
    if (!wrap || !vs.length) return;
    var cur = { c: data.c, vs: vs, tok: 0, loading: null, want: data.c };
    var title = titleOf(wrap);
    // hovering / focusing a pricier size shows its real price on the card itself (audit R2-01), then puts it back
    var priceEl = wrap.querySelector('.aa-card__p'), priceHtml = priceEl ? priceEl.innerHTML : '';
    var base0 = function () { var t = priceEl ? (priceEl.firstChild && priceEl.firstChild.textContent || '') : ''; var n = parseFloat(String(t).replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : Math.round(n * 100); };
    var showUp = function (v) { if (!priceEl) return; var u = +v[3] || 0; if (u > 0) priceEl.innerHTML = '<span>' + usd(base0() + u) + '</span>'; };
    var resetUp = function () { if (priceEl && priceEl.innerHTML !== priceHtml) priceEl.innerHTML = priceHtml; };
    var label = function (v) { return 'add ' + title + (cur.c ? ', ' + String(cur.c).toLowerCase() : '') + (v[1] ? ', size ' + v[1] : '') + ((+v[3] || 0) > 0 ? ', ' + usd(base0() + (+v[3])) : '') + ' to cart'; };

    var bar = el('div', 'aa-qa__bar');
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'quick add');
    var msg = el('span', 'aa-qa__msg'); msg.setAttribute('aria-hidden', 'true');
    bar.appendChild(msg);
    host.appendChild(bar);

    var plus = el('button', 'aa-btn-reset aa-qa__plus');
    plus.type = 'button';
    plus.innerHTML = PLUS + '<span class="aa-qa__plus-l">add</span>';
    host.appendChild(plus);

    // (re)draw the size chips for the current color; one variant (or a one-size product) = a plain "add" with the hand-drawn +
    function renderChips() {
      var single = cur.vs.length === 1;
      [].slice.call(bar.querySelectorAll('.aa-qa__chip')).forEach(function (c) { bar.removeChild(c); });
      cur.vs.forEach(function (v) {
        var b = el('button', 'aa-qa__chip' + (single ? ' aa-qa__chip--add' : ''), single ? null : sizeText(v));
        if (single) b.innerHTML = PLUS_S + '<span>add</span>';
        b.type = 'button';
        b.setAttribute('data-aa-qa-id', v[0]);
        b.setAttribute('aria-label', label(v));
        if ((+v[3] || 0) > 0) { b.addEventListener('mouseenter', function () { showUp(v); }); b.addEventListener('focus', function () { showUp(v); }); b.addEventListener('mouseleave', resetUp); b.addEventListener('blur', resetUp); }
        if (!v[2]) { b.disabled = true; b.setAttribute('aria-label', String(v[1] || title) + ', sold out'); }
        bar.appendChild(b);
      });
      plus.setAttribute('aria-label', single ? 'add ' + title + ' to cart' : 'quick add ' + title + ', choose size');
      plus.setAttribute('aria-haspopup', single ? 'false' : 'dialog');
    }
    renderChips();

    function state(s, text) { if (s) { bar.setAttribute('data-state', s); msg.textContent = text || ''; } else { bar.removeAttribute('data-state'); } }

    // swatches call this: default color = the embedded JSON (instant); any other color = the product's full
    // variant matrix, fetched once per handle the first time it is needed
    function setColor(name, handle) {
      var tok = ++cur.tok;
      cur.want = name;
      if (name === data.c) { cur.c = name; cur.vs = vs; cur.loading = null; bar.removeAttribute('data-loading'); renderChips(); return; }
      bar.setAttribute('data-loading', '');
      var pr = cur.loading = matrixFor(handle).then(function (m) {
        if (tok !== cur.tok) return;
        var list = listFor(m, name);
        if (!list.length) throw new Error('none');
        cur.c = name; cur.vs = list; renderChips();
      }).catch(function () {
        if (tok !== cur.tok) return;
        cur.c = name; cur.vs = []; renderChips();
        state('msg', 'sizes unavailable'); setTimeout(function () { state(null); }, 2200);
      }).then(function () {
        if (tok === cur.tok) { cur.loading = null; bar.removeAttribute('data-loading'); }
      });
      return pr;
    }
    host.__aaApi = { setColor: setColor, setPriceHtml: function (h) { priceHtml = h; if (priceEl) priceEl.innerHTML = h; } };

    function run(id, viaSheet) {
      if (busy || cur.loading) return;
      busy = true;
      state('busy', 'adding…');
      if (viaSheet) sheetBusy(true);
      add(id).then(function () {
        busy = false; state('msg', 'added'); say('added to cart');
        if (viaSheet) closeSheet(false);
        setTimeout(function () { state(null); }, 1400);
      }).catch(function (err) {
        busy = false;
        var m = String(err && err.message || 'sorry, that could not be added.').toLowerCase();
        state('msg', m); say(m);
        if (viaSheet) { sheetBusy(false); sheetMsg(m); }
        setTimeout(function () { state(null); }, 2200);
      });
    }

    bar.addEventListener('click', function (e) {
      var b = e.target.closest('.aa-qa__chip');
      if (!b || b.disabled) return;
      run(parseInt(b.getAttribute('data-aa-qa-id'), 10), false);
    });
    plus.addEventListener('click', function () {
      var go = function () {
        if (!cur.vs.length) return;
        if (cur.vs.length === 1) { if (cur.vs[0][2]) run(cur.vs[0][0], false); return; }
        openSheet(plus, title, cur.c, cur.vs, function (id) { run(id, true); }, base0());
      };
      if (cur.loading) cur.loading.then(go); else go();
    });
  }

  /* ---- variant matrix (only for non-default colors) ---- */
  var mcache = {};
  function matrixFor(handle) {
    if (mcache[handle]) return mcache[handle];
    var k = 'aa-pj3:' + handle;
    try {
      var st = JSON.parse(sessionStorage.getItem(k));
      if (st && st.m && Date.now() - st.t < 600000) return (mcache[handle] = Promise.resolve(st.m));
    } catch (e) {}
    return (mcache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) {
        var m = {
          n: (p.options || []).map(function (o) { return String(typeof o === 'string' ? o : o.name).toLowerCase(); }),
          v: (p.variants || []).map(function (v) { return [v.id, v.available ? 1 : 0].concat(v.options || []); }),
          pr: (p.variants || []).map(function (v) { return v.price; }),
          cp: (p.variants || []).map(function (v) { return v.compare_at_price || 0; }),
          min: p.price_min
        };
        try { sessionStorage.setItem(k, JSON.stringify({ t: Date.now(), m: m })); } catch (e) {}
        return m;
      })
      .catch(function (err) { delete mcache[handle]; throw err; }));
  }
  function listFor(m, color) {
    var ci = m.n.indexOf('color'); if (ci < 0) ci = m.n.indexOf('colour');
    var si = m.n.indexOf('size');
    if (ci < 0) return [];
    return m.v.map(function (v, i) { return [v, i]; }).filter(function (x) { return x[0][2 + ci] === color; })
      .map(function (x) { var v = x[0], up = (m.pr && m.min != null) ? (m.pr[x[1]] - m.min) : 0; return [v[0], si >= 0 ? v[2 + si] : '', v[1], up]; });
  }

  /* ---- color swatches (one line of dots under the card; markup = one JSON per card) ---- */
  var LOOP = '<span class="aa-sw__loop"><svg class="aa-loop aa-draw aa-loop--still" viewBox="0 0 200 80" preserveAspectRatio="none" aria-hidden="true" focusable="false"><path pathLength="100" d="M22 50 C 10 26, 76 6, 150 10 C 196 13, 204 42, 170 60 C 132 79, 46 80, 20 58 C 6 45, 20 22, 58 13 C 68 10.5, 78 9.5, 88 9" fill="none" stroke="#16517D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/></svg></span>';
  var MORE = 34; // px reserved at the end of the row for "+N"
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var groups = [];
  var ro = window.ResizeObserver ? new ResizeObserver(function () { queueLayout(); }) : null;
  var raf = 0;
  function queueLayout() {
    if (raf) return;
    var run = function () { if (!raf) return; raf = 0; layout(); };
    raf = 1;
    requestAnimationFrame(run); setTimeout(run, 120); // rAF is paused in background tabs
  }
  function handleOf(n) { return String(n).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }

  // never wraps: show what fits, hide the rest behind a "+N" link to the product page
  function layout() {
    groups = groups.filter(function (g) { return document.body.contains(g); });
    if (!groups.length) return;
    var pad = 0, cs = getComputedStyle(groups[0]);
    pad = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
    var jobs = groups.map(function (g) { return { g: g, w: g.clientWidth - pad, bw: g.__btns[0].offsetWidth }; });
    jobs.forEach(function (j) {
      var g = j.g, btns = g.__btns, total = btns.length;
      if (j.w <= 0 || !j.bw) return;
      var fit = Math.floor((j.w + 0.5) / j.bw);
      var k = total <= fit ? total : Math.max(1, Math.floor((j.w - MORE) / j.bw));
      var sel = g.querySelector('[aria-pressed="true"]'), si = btns.indexOf(sel);
      if (sel && si >= k) { btns.splice(si, 1); btns.splice(k - 1, 0, sel); g.insertBefore(sel, btns[k]); }
      btns.forEach(function (b, i) { var h = i >= k; if (b.hidden !== h) b.hidden = h; });
      var more = g.__more, n = total - k;
      if (n > 0) { var t = '+' + n; if (more.textContent !== t) { more.textContent = t; more.setAttribute('aria-label', n + ' more color' + (n > 1 ? 's' : '') + ', view product'); } more.hidden = false; }
      else more.hidden = true;
      g.setAttribute('data-shown', k);
    });
  }
  window.addEventListener('resize', queueLayout);

  function swapImage(wrap, url, prefix) {
    if (!url) return;
    var img = wrap.querySelector('.aa-card__media img');
    if (!img) return;
    var u = prefix + url;
    var src = u + '?width=540';
    if (img.getAttribute('src') === src) return;
    var ss = [360, 540, 720, 900].map(function (w) { return u + '?width=' + w + ' ' + w + 'w'; }).join(', ');
    var tok = wrap.__imgTok = (wrap.__imgTok || 0) + 1;
    var apply = function () {
      if (tok !== wrap.__imgTok) return;
      img.srcset = ss; img.src = src; img.style.opacity = '';
    };
    if (!reduce) img.style.opacity = '.55';
    var pre = new Image();
    if (img.sizes) pre.sizes = img.sizes;
    pre.onload = pre.onerror = apply;
    pre.srcset = ss; pre.src = src;
  }

  function buildSw(g) {
    if (g.__aaSw) return;
    var data;
    try { data = JSON.parse(g.querySelector('script').textContent); } catch (e) { return; }
    var wrap = g.closest('.aa-cardw');
    var link = wrap && wrap.querySelector('a.aa-card');
    var cs = data.c || [];
    if (!link || cs.length < 2) return;
    g.__aaSw = true;
    var base = (link.getAttribute('href') || '').split('?')[0];
    var hm = base.match(/\/products\/([^\/?#]+)/);
    var handle = hm ? decodeURIComponent(hm[1]) : '';
    var btns = [];
    var frag = document.createDocumentFragment();
    cs.forEach(function (c, i) {
      var b = el('button', 'aa-sw__b' + (c[2] < 0 ? ' is-out' : ''));
      b.type = 'button';
      b.setAttribute('aria-label', c[0]);
      b.setAttribute('aria-pressed', i === data.d ? 'true' : 'false');
      b.__i = i;
      var d = el('span', 'aa-sw__d');
      d.style.background = 'var(--' + handleOf(c[0]) + ', #d9d7d0)';
      b.appendChild(d);
      if (i === data.d) b.insertAdjacentHTML('beforeend', LOOP);
      btns.push(b); frag.appendChild(b);
    });
    var more = el('a', 'aa-sw__more'); more.href = base; more.hidden = true;
    frag.appendChild(more);
    g.appendChild(frag);
    g.__btns = btns; g.__more = more;
    groups.push(g);
    if (ro) ro.observe(g);
    queueLayout();
    // a loop built after aa-loop.js ran needs a nudge: flip aria-pressed so its observer draws it once, then hold it still
    var sb = btns[data.d];
    if (sb) { sb.setAttribute('aria-pressed', 'false'); sb.setAttribute('aria-pressed', 'true'); Promise.resolve().then(function () { var s = sb.querySelector('.aa-loop'); if (s) s.classList.add('aa-loop--still'); }); }

    var warmed = false;
    function warm() { if (warmed || !handle || !wrap.querySelector('[data-aa-qa]')) return; warmed = true; matrixFor(handle).catch(function () { warmed = false; }); }
    g.addEventListener('pointerenter', warm);
    g.addEventListener('focusin', warm);
    g.addEventListener('touchstart', warm, { passive: true });

    // a size-filtered collection (e.g. 5XL) must keep that size when the color changes (audit R6-05): pick this
    // color's variant in a filtered size, carry its price, and never fall back to the color's first size (XS)
    function filterSizes() {
      try { return new URLSearchParams(location.search).getAll('filter.v.option.size').map(function (x) { return String(x).toLowerCase(); }); } catch (err) { return []; }
    }
    function inSize(m, color, sizes) {
      var ci = m.n.indexOf('color'); if (ci < 0) ci = m.n.indexOf('colour');
      var si = m.n.indexOf('size');
      if (ci < 0 || si < 0) return null;
      for (var i = 0; i < m.v.length; i++) {
        var v = m.v[i];
        if (v[1] && String(v[2 + ci]) === color && sizes.indexOf(String(v[2 + si]).toLowerCase()) >= 0) return { id: v[0], price: m.pr[i], cmp: (m.cp && m.cp[i]) || 0 };
      }
      return null;
    }
    function priceHtmlFor(price, cmp) {
      return usd(price) + (cmp > price ? '<span class="aa-card__was"><span class="aa-sale">( sale )</span> <s class="aa-muted"><span class="aa-visually-hidden">regular price </span>' + usd(Math.floor(cmp / 100) * 100) + '</s></span>' : '');
    }
    function markNoSize(b, color, sizes) {
      b.classList.add('is-out', 'is-nosize');
      b.setAttribute('aria-label', color + ', not available in ' + sizes.join(' or '));
      b.title = 'not available in ' + sizes.join(' or ');
    }
    // once the matrix is loaded on a size-filtered page, show which colors don't come in that size
    function markSizes() {
      var sizes = filterSizes();
      if (!sizes.length || !handle) return;
      matrixFor(handle).then(function (m) {
        btns.forEach(function (b) { var col = cs[b.__i][0]; if (!inSize(m, col, sizes)) markNoSize(b, col, sizes); });
      }).catch(function () {});
    }
    g.addEventListener('pointerenter', markSizes, { once: true });
    g.addEventListener('focusin', markSizes, { once: true });
    g.addEventListener('touchstart', markSizes, { once: true, passive: true });

    function selectSwatch(b, c, id, price) {
      var old = g.querySelector('.aa-sw__b[aria-pressed="true"]');
      var loop = old && old.querySelector('.aa-sw__loop');
      if (old) old.setAttribute('aria-pressed', 'false');
      if (loop) b.appendChild(loop); else b.insertAdjacentHTML('beforeend', LOOP);
      b.setAttribute('aria-pressed', 'true');
      link.setAttribute('href', base + '?variant=' + id);
      wrap.classList.add('is-recolored'); // the hover image is a different color: stop showing it
      swapImage(wrap, c[1] === 0 ? String(data.t || '').replace('~', handleOf(c[0])) : c[1], data.p || '');
      var host = wrap.querySelector('[data-aa-qa]');
      if (host && host.__aaApi) host.__aaApi.setColor(c[0], handle);
      if (price) { var pe = wrap.querySelector('.aa-card__p'); if (host && host.__aaApi && host.__aaApi.setPriceHtml) host.__aaApi.setPriceHtml(price); else if (pe) pe.innerHTML = price; }
      say(String(c[0]).toLowerCase());
    }

    g.addEventListener('click', function (e) {
      var b = e.target.closest('.aa-sw__b');
      if (!b || b.getAttribute('aria-pressed') === 'true') return;
      var c = cs[b.__i], id = Math.abs(c[2]);
      var sizes = filterSizes();
      if (!sizes.length || !handle) { selectSwatch(b, c, id, null); return; }
      if (b.classList.contains('is-nosize')) { say(String(c[0]).toLowerCase() + ' isn’t available in ' + sizes.join(' or ')); return; }
      matrixFor(handle).then(function (m) {
        var hit = inSize(m, c[0], sizes);
        if (!hit) { markNoSize(b, c[0], sizes); say(String(c[0]).toLowerCase() + ' isn’t available in ' + sizes.join(' or ')); return; }
        selectSwatch(b, c, hit.id, priceHtmlFor(hit.price, hit.cmp));
      }).catch(function () { selectSwatch(b, c, id, null); });
    });
  }

  function scan(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-aa-sw]'), buildSw);
    [].forEach.call((scope || document).querySelectorAll('[data-aa-qa]'), build);
  }

  /* ---- bottom sheet (touch) ---- */
  var sheet = null, sheetOpener = null, sheetPick = null;
  function sheetBusy(b) { if (sheet) sheet.classList.toggle('is-busy', b); }
  function sheetMsg(t) { if (sheet) sheet.querySelector('.aa-qs__msg').textContent = t || ''; }
  function ensureSheet() {
    if (sheet) return sheet;
    sheet = el('div', 'aa-qs');
    sheet.hidden = true;
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'quick add');
    sheet.innerHTML = '<div class="aa-qs__back"></div><div class="aa-qs__panel"><div class="aa-qs__head"><div><p class="aa-qs__title"></p><p class="aa-qs__sub"></p></div><button type="button" class="aa-btn-reset aa-qs__close" aria-label="Close">' + CLOSE + '</button></div><div class="aa-qs__chips" role="group" aria-label="size"></div><p class="aa-qs__msg" role="alert"></p></div>';
    document.body.appendChild(sheet);
    sheet.querySelector('.aa-qs__back').addEventListener('click', function () { closeSheet(true); });
    sheet.querySelector('.aa-qs__close').addEventListener('click', function () { closeSheet(true); });
    sheet.querySelector('.aa-qs__chips').addEventListener('click', function (e) {
      var b = e.target.closest('.aa-qs__chip');
      if (b && !b.disabled && sheetPick) { sheetMsg(''); sheetPick(parseInt(b.getAttribute('data-id'), 10)); }
    });
    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); closeSheet(true); return; }
      if (e.key !== 'Tab') return;
      var f = [].filter.call(sheet.querySelectorAll('button:not([disabled])'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    return sheet;
  }
  function openSheet(opener, title, color, vs, pick, base) {
    var s = ensureSheet();
    sheetOpener = opener; sheetPick = pick;
    s.querySelector('.aa-qs__title').textContent = title;
    var pn = priceNote(vs, base);
    s.querySelector('.aa-qs__sub').textContent = (color ? String(color).toLowerCase() + ' · ' : '') + (pn ? pn : 'choose a size');
    var chips = s.querySelector('.aa-qs__chips');
    chips.innerHTML = '';
    vs.forEach(function (v) {
      var b = el('button', 'aa-qs__chip', sizeText(v));
      b.type = 'button'; b.setAttribute('data-id', v[0]);
      if (!v[2]) { b.disabled = true; b.setAttribute('aria-label', v[1] + ', sold out'); }
      chips.appendChild(b);
    });
    sheetMsg(''); sheetBusy(false);
    clearTimeout(sheetT); s.classList.remove('is-closing');
    s.hidden = false;
    document.documentElement.classList.add('aa-qs-open');
    var f = chips.querySelector('button:not([disabled])') || s.querySelector('.aa-qs__close');
    f.focus();
  }
  var sheetT = 0;
  function closeSheet(restore) {
    if (!sheet || sheet.hidden || sheet.classList.contains('is-closing')) return;
    document.documentElement.classList.remove('aa-qs-open');
    if (restore && sheetOpener) sheetOpener.focus();
    var s = sheet;
    s.classList.add('is-closing');
    clearTimeout(sheetT);
    sheetT = setTimeout(function () { s.classList.remove('is-closing'); s.hidden = true; }, 230);
  }

  /* ---- boot; watch for ajax-swapped grids ---- */
  scan();
  if (window.MutationObserver) {
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 60); })
      .observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) closeSheet(false); });
})();
